import React from 'react';
import PropTypes from 'prop-types';
import { AspectRatioCard } from '@homeaway/react-aspect-ratio-card';
import { SHORT_CAROUSEL_ASPECT_RATIO } from '../Carousel/constants';
import Placeholder from './Placeholder';

const DummyCard = ({ svgIcon }) => (
  <AspectRatioCard
    aspectRatio={SHORT_CAROUSEL_ASPECT_RATIO}
    hasHover={false}
  >
    <Placeholder svgIcon={svgIcon} data-slot={'figure'} />
  </AspectRatioCard>
);

DummyCard.propTypes = {
  svgIcon: PropTypes.string
};

export default DummyCard;
